import React, { useState } from 'react'
import { doc, writeBatch } from 'firebase/firestore'
import { showErrorToast, showSuccessToast } from 'app/components/ShowToast'
import db from 'services/firebase'
import Button from 'app/components/Button'

interface AssignOwnerFormProps {
  personnels: any[]
  checkedItems: string[]
  onClose: () => void
  onSuccess: () => void
  currentUser: any
  collectionName: 'controls' | 'tests' | 'risks'
  fieldName?: string 
}

const AssignOwnerForm: React.FC<AssignOwnerFormProps> = ({
  personnels,
  checkedItems,
  onClose,
  onSuccess,
  currentUser,
  collectionName,
  fieldName = 'control_owner'
}) => {
  const [assignOwner, setAssignOwner] = useState('')

  const handleAssignOwner = async () => {
    if (!assignOwner) {
      return
    }

    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) return

    const tenantRef = doc(db, 'tenants', tenantId)
    const batch = writeBatch(db)

    for (const itemId of checkedItems) {
      const itemRef = doc(tenantRef, collectionName, itemId)
      batch.update(itemRef, { [fieldName]: assignOwner })
    }

    try {
      await batch.commit()
      showSuccessToast({ message: `${collectionName === 'controls' ? 'Control' : collectionName === 'tests' ? 'Test' : 'Risk'} owner updated successfully` })
      onSuccess()
      onClose()
      setAssignOwner('')
    } catch (error) {
      showErrorToast({ message: `Failed to update ${collectionName === 'controls' ? 'control' : collectionName === 'tests' ? 'test' : 'risk'} owner` })
    }
  }

  const handleResetClick = () => {
    setAssignOwner('')
    onClose()
  }

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className='mb-3'>
        <div className='mb-3 d-flex align-items-center'>
          <select
            id='owner'
            className='form-select form-control'
            aria-label='Select Owner'
            value={assignOwner}
            onChange={(e) => setAssignOwner(e.target.value)}
          >
            <option value='' disabled>
              Select Owner
            </option>
            {personnels
              .filter(
                (user) => user.role === 'Admin' || user.role === 'Owner'
              )
              .map((personnel) => (
                <option key={personnel.id} value={personnel.full_name}>
                  {personnel.full_name}
                </option>
              ))}
          </select>
          {assignOwner && (
            <button
              className='btn btn-link p-0'
              onClick={() => setAssignOwner('')}
              type='button'
            >
              <span aria-hidden='true' className='mx-2 fw-bold fs-2'>
                &times;
              </span>
            </button>
          )}
        </div>
      </div>
      <div className='d-flex gap-2'>
        <Button
          btnType='secondary'
          onClick={handleResetClick}
        >
          Reset
        </Button>
        <Button
          btnType='primary'
          onClick={handleAssignOwner}
        >
          Apply
        </Button>
      </div>
    </form>
  )
}

export default AssignOwnerForm 